import { useSessionStore } from "../../../stores/UserStore";
import { Stack } from "@mantine/core";
import {
  IconAddressBook,
  IconHelp,
  IconSettings,
  IconSpeakerphone,
  IconTimelineEvent,
} from "@tabler/icons-react";

export function getKnowledgesEN() {
  const reseller = useSessionStore.getState().reseller;

  const result = [
    {
      url: "contact-lists",
      icon: IconAddressBook,
      title: "Contact Lists",
      desc: "All knowledge about contact lists",
      items: [
        {
          url: "filters",
          title: "Filter my contacts in a list",
          content: (
            <Stack>
              <p>
                Once your list is created, you will have the possibility to sort
                your list. If it doesn't suit you, or if you want to filter it,
                you can then exclude contacts. <br />
              </p>
              <p>
                On the Contacts page, you can click on the name of your list and
                you will see the details of your list.
                <br />
              </p>
              <p>
                You will find a "Filters" icon above your list, which will allow
                you to exclude contacts from your list,
                <br />
              </p>
              <p>
                For example: I want to delete all contacts whose "job title"
                contains "Assistant".{" "}
              </p>
            </Stack>
          ),
        },
        {
          url: "page",
          title: "Contacts Page Features",
          content: (
            <Stack>
              <p>
                The list tab allows you to find all of your contact lists in
                order to carry out your prospecting campaigns.
                <br />
                <br />
              </p>
              <p>
                You will find all the features and tools for good management of
                your contact lists
                <br />
              </p>
              <ul>
                <li>
                  Create a list from our B2B contact database
                  <br />
                </li>
                <li>Create a list from LinkedIn</li>
                <li>Create your lists from Google</li>
                <li>Import your lists</li>
              </ul>

              {/* Image here */}

              <p>
                <b>
                  FOLDERS VIEW
                  <br />
                </b>
              </p>
              <ul>
                <li>
                  Show all lists
                  <br />
                </li>
                <li>Create a folder</li>
                <li>Rename a folder</li>
                <li>Delete a folder</li>
                <li>Search for a folder</li>
              </ul>
              <p>
                <b>
                  <br />
                  "ACTION" COLUMN
                  <br />
                  "Pencil" button you can:
                </b>
              </p>
              <ul>
                <li>Rename your list</li>
                <li>Add Tags</li>
                <li>Create and move your list into a folder</li>
              </ul>
              <p>
                <br />
              </p>
              <p></p>
              <p>
                <b>"+" button you can:</b>
                <br />
              </p>
              <ul>
                <li>View your list's contacts in a new tab</li>
                <li>Import a contact list from a file</li>
                <li>Import a contact list by copy-pasting</li>
                <li>Download your file in CSV or XLSX</li>
                <li>Duplicate your list</li>
                <li>Copy a list to a user, a team, a company</li>
                <li>Copy your list to the PRM</li>
                <li>Split your list into X lists (splitter)</li>
              </ul>
              <p>
                <br />
              </p>
              <p>
                <b>"Trash" button</b>
                <br />
              </p>
              <ul>
                <li>Delete your list</li>
              </ul>
              <p>
                <br />
                <b>INFO </b>: You can select multiple lists to perform one of
                the actions simultaneously
              </p>

              {/* Image here */}

              <p>
                <b>"ACTION" COLUMN</b>
              </p>
              <ul>
                <li>Download your contacts in CSV or XLSX</li>
                <li>Duplicate your contact selection into a new list</li>
                <li>Copy a list to a user, a team, a company</li>
                <li>
                  Copy your contact selection to a user, a team, a company
                </li>
                <li>Copy your contact selection to the PRM</li>
                <li>Split your contact selection into X lists (splitter)</li>
              </ul>
              <p>
                <br />
              </p>
              <p>
                <b>"Trash" button</b>
              </p>
              <ul>
                <li> Delete your list</li>
              </ul>
              <p></p>
              <p></p>

              {/* Image here */}

              <p>
                <b>
                  Quick access toolbar
                  <br />
                </b>
              </p>
              <ul>
                <li>Search in a list or folders</li>
                <li>Multi-criteria search filter with conditions</li>
                <li>Column display management</li>
                <li>Export a list or folder</li>
                <li>Delete a list or folder</li>
              </ul>
            </Stack>
          ),
        },
      ],
    },
    {
      url: "configurations",
      icon: IconSettings,
      title: "Settings",
      desc: "Configure the prospecting software",
      items: [
        {
          url: "add-exclusions",
          title: "Create your unsubscribe or Blacklists",
          content: (
            <Stack>
              <p>
                On the platform, you have the possibility to exclude contacts
                from your campaigns.
                <br />
                <br />
                Thus they will not receive your messages and will be
                automatically excluded from your campaigns / scenarios.
                <br />
                <br />{" "}
              </p>
              <p>
                This is a precautionary principle in order not to solicit your
                prospects, clients, partners, suppliers, etc... without having
                to manually check each contact on your list before sending your
                campaign.
                <br />
                <br />
              </p>
              <p>To do this, you just need to:</p>
              <p>
                {" "}
                Import a list of contacts as a CSV file here{" "}
                <a
                  href={`https://${
                    reseller?.domain_saas3 || reseller?.domain_saas2
                  }/exclusions/blacklists`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                  /exclusions/blacklists.
                  <br />
                </a>
                OR click on the "Configuration" &gt; "Blacklist" &gt; "Import" a
                list of contacts to exclude. <br />
                <br />
                You can also create folders for your exclusion lists by type of
                exclusion, such as your clients, people to never contact...
                <br />
                <br />
              </p>
              <p>
                The unsubscription keys taken into account by the system are:
                email, domain name, SIRET, SIREN, LinkedIn link, or company
                name.
                <br />
                <br />
              </p>
              <p>
                <b>To permanently unsubscribe contacts</b>, You must go to this
                page:{" "}
                <a
                  href={`https://${
                    reseller?.domain_saas3 || reseller?.domain_saas2
                  }/exclusions/unsubscribers`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                  /exclusions/unsubscribers
                </a>{" "}
                .<br />
                Or click on the "Configuration" &gt; "Unsubscribed list"
                <br />
                <br />
              </p>
              <p>
                <b>Warning</b>: The file must contain only one piece of
                information per line. <br />
                This information can be mixed in your import file.
                <br />
                <b>
                  <br />
                </b>
              </p>
              <p>
                <b>
                  The difference between an exclusion list and an
                  unsubscription:
                  <br />
                  <br />
                </b>
              </p>
              <p>
                {" "}
                <b>Unsubscription </b>is automatic and irreversible: Once the
                contact is marked as unsubscribed, you can be sure that they
                will no longer receive anything from you.
                <br />
                <br />
              </p>
              <p>
                {" "}
                <b>The exclusion list</b> is selected for each campaign
                depending on whether or not you want to take it into account for
                each send.
              </p>
            </Stack>
          ),
        },
        {
          url: "connect-email",
          title: "Connect my e-mail account",
          content: (
            <Stack>
              <p>
                Before launching an e-mail campaign, you must pay attention to
                the sending method and the chosen sender e-mail.
              </p>
              <p>You will have two alternatives:</p>
              <ol>
                <li>
                  {" "}
                  Mass mailing: this allows sending campaigns to large volumes
                  and quickly, but with a lower open rate.
                  <br />
                  The sends (routing) are done through the {reseller?.name}
                  platform. You have the option to configure an alias when
                  sending. An alias (artifact) is the email that will be seen by
                  your prospects, but which will not be used during sends.
                  <br />
                  <b>Warning</b>, {reseller?.name} will never appear during your
                  mass mailing sends
                </li>
                <li>
                  {" "}
                  Send from your e-mail box: This allows you to increase your
                  response rates by communicating with each prospect on an
                  individual level.
                </li>
              </ol>
              <p>
                {" "}
                You can connect your e-mail boxes to the platform. You will be
                able to see the e-mails sent in your "Sent E-mails" tab in your
                mailbox when the campaign is sent.{" "}
              </p>
              <p>
                Warning, we recommend limiting sends to 100 e-mails / day per
                sender e-mail.
                <br />
                <br />
              </p>
              <p>
                <b>
                  To configure your e-mails, we invite you to click on the link:{" "}
                </b>
              </p>
              <p>
                <a
                  href={`https://${
                    reseller?.domain_saas3 || reseller?.domain_saas2
                  }/senders/email`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                  /senders/email
                </a>{" "}
                or go to the "Tool" &gt; Sender Emails
              </p>
              <p>You will have two possibilities:</p>
              <ol>
                <li>
                  {" "}
                  Click on "Add your email as a sender" (blue button) which
                  corresponds to adding a mass mailing alias.
                  <br />- Enter your e-mail then validate on "Save". You will
                  receive a validation e-mail in your mailbox to ensure that the
                  domain belongs to you.
                </li>
                <li>
                  {" "}
                  Click on "Send your e-mail from your SMTP domain" (green
                  button) which corresponds to connecting your mailbox.
                </li>
              </ol>
              <p>
                {" "}
                When the pop-up opens, select the provider of your e-mail
                account
              </p>
              <ul>
                <li>
                  For Gmail or Outlook, select the e-mail address you want to
                  add then follow the next steps.
                </li>
                <li>
                  For other e-mail providers, fill in the requested information.
                  <br />
                  <br />
                </li>
              </ul>
              <p>
                <b>Additional configuration:</b>
              </p>
              <p>
                These options will allow you to optimize the proper reception of
                your e-mails:
              </p>
              <ul>
                <li> Enable / Disable the unsubscribe link.</li>
                <li> Enable / Disable tracking of openers/clickers.</li>
                <li>
                  {" "}
                  Sending frequencies: Time lapse between two e-mail sends.
                </li>
                <li>
                  {" "}
                  Warm UP: E-mail warm-up (IP reputation preservation
                  technique).
                </li>
                <li>
                  {" "}
                  SMTP Pool: Ability to link your sender e-mails to an SMTP
                  pool.
                </li>
              </ul>
            </Stack>
          ),
        },
        {
          url: "email-validation",
          title: "E-mail Validation",
          content: (
            <Stack>
              <p>
                <i>
                  <b>Question </b>: I received the validation email for adding
                  an E-mail account from:{" "}
                  <a
                    href={`http://${
                      reseller?.domain_saas3 || reseller?.domain_saas2
                    }`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {reseller?.domain_saas3 || reseller?.domain_saas2}
                  </a>{" "}
                  info@{reseller?.domain_saas3 || reseller?.domain_saas2} which
                  seems abnormal to me.
                </i>
              </p>
              <br />
              <p>
                <b>Answer </b>: This is not an error, because the validation of
                a new account (system procedure) comes from the{" "}
                <b>{reseller?.name}</b> platform.
                <br />
              </p>
              <p>
                In order to have a personalized sender for alerts or software
                validations, you must change your plan to switch to White Label.
                <br />
              </p>
              <p>Please contact the sales department about this</p>
            </Stack>
          ),
        },
        {
          url: "create-signature",
          title: "Create your e-mail signatures",
          content: (
            <Stack>
              <p>
                When you create an e-mail, you can add your signature to the
                content. <br />
              </p>
              <p>
                To do this, you can first import your signature onto the
                platform.
              </p>
              <p>
                Click on the link{" "}
                <a
                  href={`https://${
                    reseller?.domain_saas3 || reseller?.domain_saas2
                  }/models/email-signature`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                  /models/email-signature
                </a>{" "}
                then click on the "Create a signature" button
              </p>
              <p>
                Or go to the "Configurations" &gt; E-mail Signatures.
                <br />
              </p>
              <p>
                Once your signature is added, when you modify or create your
                scenario template, you can click on the "Signature" button to
                add your signature by choosing one of the already created
                signatures. <br />
                <br />
              </p>
              <p>
                <b>INFO </b>: When creating your e-mail messages, you can still
                preview your message with the desired signature
              </p>
              <p></p>
            </Stack>
          ),
        },
        {
          url: "dynamic-columns",
          title: "Dynamic columns",
          content: (
            <Stack>
              <p>
                Dynamic columns are used when importing a contact list and the
                columns in your file were not planned for and created by the
                software.
              </p>

              {/* Image here */}

              <p>
                To overcome this lack of columns, when importing your file, you
                have the option to create these dynamic columns.
                <br />
                <br />
              </p>
              <p>
                For managing these columns: adding or deleting, you can go here:{" "}
                <a
                  href={`https://${
                    reseller?.domain_saas3 || reseller?.domain_saas2
                  }/settings/tools/datafields`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                  /settings/tools/datafields
                </a>
              </p>
              <p>Or in the "Configurations" &gt; "Dynamic columns"</p>
              <p>
                <br />
                In the "<b>Action</b>" column, you can:{" "}
              </p>
              <p>
                <b>Delete </b>: allows you to delete the dynamic column.
              </p>
              <p>
                <br />
                <b>WARNING </b>: This action of deleting a dynamic column will
                also delete <b>ALL THE DATA</b> in this <br />
                <br />
                The "<b>Share</b>" column allows you to share this column with
                your collaborators, a team, or a company.
              </p>
            </Stack>
          ),
        },
      ],
    },
    {
      url: "campaigns",
      icon: IconSpeakerphone,
      title: "Campaigns",
      desc: "The basics of your campaign sends",
      items: [
        {
          url: "statistics",
          title: "Your campaign statistics",
          content: (
            <Stack>
              <p>
                On the {reseller?.name} platform, you have statistics for your
                campaigns.
                <br />
              </p>
              <p>
                On your dashboard, you will find the number of emails sent,
                scheduled emails, clicked emails, opened emails, received
                emails.
                <br />
              </p>
              <p>
                For LinkedIn campaigns, the KPIs to follow will be the
                acceptance rates of your invitations (relationship level 1), the
                response rates, and the read rates of your messages
                (relationship level 2 and 3).
                <br />
              </p>
              <p>
                The data is reproduced in table form: so you have statistics
                analyzing your campaigns organized campaign by campaign.
                <br />
              </p>
              <p>
                Click on the link:{" "}
                <a
                  href={`https://${
                    reseller?.domain_saas3 || reseller?.domain_saas2
                  }/statistics/campaigns`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                  /statistics/campaigns
                </a>
              </p>
              <p>Or go to the "Campaigns" tab</p>
              <p>
                <br />
                <b>In the table you will find:</b>
              </p>
              <ul>
                <li>
                  {" "}
                  Scheduled emails: the number of emails that are currently
                  running.
                </li>
                <li> The number of emails sent from the scheduled emails.</li>
                <li>
                  {" "}
                  Opened emails: The number of emails opened upon receipt.
                </li>
                <li>
                  {" "}
                  Clicked emails: the number of emails where there is a link
                  that the receiver clicked on.
                </li>
                <li>
                  {" "}
                  The number of responses received following the sending of
                  emails.
                </li>
              </ul>
              <p>
                <br />
                If you want more details and to access daily sending statistics,
                you can click on the "Report" icon to the right of each of your
                campaigns on the statistics tab.{" "}
              </p>
            </Stack>
          ),
        },
        {
          url: "view-campaigns",
          title: "Find my scheduled campaigns",
          disabled: true,
          content: (
            <Stack>
              <p>
                You have the possibility to see all your campaigns once they are
                scheduled by clicking on the "Campaigns" tab:
                <br />
              </p>
              <p>
                You can quickly filter your campaigns by choosing "In progress,
                Paused, Error, Archived"
                <br />
                <br />
                You can also use the multi-criteria filters via the "Filters"
                function
                <br />
              </p>
            </Stack>
          ),
        },
      ],
    },
    {
      url: "leads-tracking",
      icon: IconAddressBook,
      title: "Lead Tracking",
      desc: "Prospect Relationship Management",
      items: [
        {
          url: "general",
          title: "Lead tracking in general",
          disabled: true,
          content: (
            <Stack>
              <p>
                For each campaign sent, the system creates a folder on the
                platform in which it stores your active contacts: this is the
                PRM (Prospect Relationship Management).
                <br />
              </p>
              <p>
                We do not manage a PRM like we manage a CRM (Customer
                Relationship Management).
                <br />
              </p>
              <p>
                For a simple reason: a client is not a prospect and we do not
                address a client in the same way as a prospect.
                <br />
              </p>
              <p>
                The relational approaches and the resulting actions are
                different!
              </p>
              <p>
                Unlike a CRM, the PRM allows you to automate follow-up tasks
                through the scenario, direct the prospect towards new
                prospecting loops, and activate nurturing according to their
                status: interested, not yet ready...
                <br />
              </p>
              <p>
                Thus, in each folder, you will find the prospects of each
                campaign independently: openers, clickers, responders, people
                who accepted your LinkedIn invitation, people who replied to you
                on LinkedIn, etc.
                <br />
              </p>
              <p>
                The PRM is accessible at{" "}
                <a
                  href={`https://${
                    reseller?.domain_saas3 || reseller?.domain_saas2
                  }/leads-tracking`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                  /leads-tracking
                </a>{" "}
              </p>
              <p>
                or through the "PRM" tab.
                <br />
              </p>
              <p>
                In each PRM folder, you will find your active contacts,
                classified by status and in descending scoring order.
                <br />
              </p>
              <p>
                You can also synchronize automatically with your CRM after
                creating a synchronization with {reseller?.name} or download
                your active contacts and work on them directly in your CRM
              </p>
            </Stack>
          ),
        },
      ],
    },
    {
      url: "workflows",
      icon: IconTimelineEvent,
      title: "Scenario",
      desc: "Everything about scenarios",
      items: [
        {
          url: "create-email",
          title: "Create a scenario",
          content: (
            <Stack>
              <p>
                On the platform, you can create scenarios that represent a
                succession of actions triggered by predefined conditions.
                <br />
                <br />
              </p>
              <p>
                To create a new scenario, we invite you to go to this link:{" "}
                <a
                  href={`https://${
                    reseller?.domain_saas3 || reseller?.domain_saas2
                  }/campaign/create`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                  /campaign/create
                  <br />
                  <br />
                </a>
              </p>
              <p>
                Or go to the "My Scenarios" &gt; Create a new scenario&gt;Add a
                scenario name.
                <br />
                <br />
              </p>
              <p>Here is the procedure to follow to create a scenario:</p>
              <ol>
                <li>
                  Choose the channel you want from LinkedIn / Email / SMS /
                  Voice Message.
                </li>
                <li>
                  {" "}
                  First message: Add your prospecting message to your scenario
                  tree by clicking on the small plus below the initial action.
                </li>
                <li>
                  {" "}
                  Follow-up: Choose the channel through which you want to send
                  the follow-up.
                </li>
                <li>
                  {" "}
                  Select the population that will receive your follow-up
                  (openers, clickers, non-actives, people who accepted your
                  LinkedIn invitation, etc.) and the delay within which your
                  follow-up will be sent.
                </li>
                <li> Add the content of your follow-up messages.</li>
                <li>
                  {" "}
                  Save your scenario.
                  <br />
                  <br />
                </li>
              </ol>
              <p>
                <b>Warning</b>, make sure you have previously created your
                different messages on the link:{" "}
                <a
                  href={`https://${
                    reseller?.domain_saas3 || reseller?.domain_saas2
                  }/models/email`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                  /models/email
                </a>{" "}
                or by going to the "My Email Templates" tab
              </p>
            </Stack>
          ),
        },
      ],
    },
    {
      url: "faq-guides-questions",
      icon: IconHelp,
      title: "FAQ, GUIDES & QUESTIONS",
      desc: "Frequently asked questions about the application",
      items: [
        {
          url: "smtp-limit",
          title: "SMTP limit reached",
          content: (
            <Stack>
              <p>
                <b>Question </b>:{" "}
                <i>
                  I am trying to enter new sender emails, and when I get to the
                  end of the entry I get an error message saying: SMTP LIMIT
                  reached
                </i>
              </p>

              <br />
              <p>
                <b>Answer </b>: You have reached the limit of the number of
                accounts to integrate into the software.
              </p>
              <p>
                You must check the account limit of your offer.
                <br />
              </p>
              <p>
                If you wish to have more SMTP accounts, please upgrade to a
                higher offer
              </p>
            </Stack>
          ),
        },
        {
          url: "edit-sender-name",
          title: "How to change the sender name?",
          content: (
            <Stack>
              <p>
                <b>Question </b>:{" "}
                <i>
                  When a prospect replies to an email, I receive this email from
                  "Nicolas from {reseller?.name}". How to change the sender
                  name?
                </i>
              </p>
              <br />
              <p>
                <b>Answer </b>: When you create/modify your email here:{" "}
                <a
                  href={`https://${
                    reseller?.domain_saas3 || reseller?.domain_saas2
                  }/models/email`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                  /models/email
                </a>
                <br />
                <br />
              </p>
              <p>
                To the right of the "return e-mail" field you have a "+" which
                allows you to choose the reply option
                <br />
              </p>
              <ol>
                <li>
                  ==&gt; Option 01: You receive the e-mail directly as if your
                  prospect was replying to you directly without the reply
                  passing through our platform. At that point, you will no
                  longer have the reported problems, but we will not be able to
                  save the received reply inside our platform
                  <br />
                  <br />
                </li>
                <li>
                  ==&gt; Option 02: (the one currently selected) When the
                  prospect replies, they reply to our server which forwards the
                  e-mail to you, which is why you see "Nicolas from{" "}
                  {reseller?.name}" appear. This solution allows us to save the
                  prospect's reply inside the platform.
                  <br />
                  <br />
                </li>
              </ol>
              With this solution, once you receive the reply, it is better to
              open a new conversation to continue the exchange with your
              prospect.
            </Stack>
          ),
        },
        {
          url: "checkout-failed",
          title: "Why is my card payment failing?",
          content: (
            <Stack>
              <p>
                We use a secure payment system (3D secure) approved by the ACPR,
                under number 16568 to protect your purchases.
                <br />
                <br />
              </p>
              <p>
                Check for an SMS to validate your purchase. <br />
                If the problem persists, contact us.
              </p>
            </Stack>
          ),
        },
        {
          url: "segment-contact-list",
          title: "Is it possible to segment my contact lists?",
          content: (
            <Stack>
              <p>
                <b>Yes, </b>by creating as many prospecting contact lists as you
                want.
                <br />
                <br />
              </p>
              <p>
                Thanks to our intelligent filters, you can combine search
                filters: Job title, activity sector, NAF code, Workforce,
                Revenue, civility, center of interest, skill center…
                <br />
                <br />
              </p>
              <p>
                If you are missing a filter among our 20 filters, do not
                hesitate to ask us.
              </p>
            </Stack>
          ),
        },
        {
          url: "database-reactive",
          title: "Is your contact database reactive?",
          content: (
            <Stack>
              <p>
                <b>Yes</b>, because our databases are tested when sending
                emailings for our clients.
                <br />
              </p>
              <p>
                Thanks to the trackers we put in our emails when sending, it is
                possible for us to control if the prospect opens their e-mail
                box.
                <br />
              </p>
              <p>
                If a prospect does not open their mailbox within the month, we
                isolate this contact so as not to prospect them anymore.
                <br />
              </p>
              <p>
                This allows us to have a reactive B2B contact database.
                <br />
              </p>
            </Stack>
          ),
        },

        {
          url: "is-it-french",
          title: "Is your solution developed in France?",
          content: (
            <Stack>
              <p>
                <b>Yes</b>, our solution is 100% French
                <br />
              </p>
              <ul>
                <li> It is developed in France</li>
                <li> It is hosted on secure servers in France by OVH</li>
                <li>
                  {" "}
                  All {reseller?.name} data and our clients' data will be stored
                  on secure servers in France
                </li>
              </ul>
            </Stack>
          ),
        },
        {
          url: "what-is-your-data-sources",
          title: "What are the sources of your files",
          content: (
            <Stack>
              <p>
                The main sources of our professional B2B database come from
                files already constituted by specialized professional
                directories and leaders in their fields:
                <br />
              </p>
              <ul>
                <li> Public data from social networks</li>
                <li>
                  {" "}
                  The legal information database from INSEE, Infogreffe, Bodacc,
                  Legi France, RNCS...
                </li>
                <li>
                  {" "}
                  From the CCI: The portal of the Chambers of Commerce and
                  Industry
                </li>
                <li> The official directory of artisans</li>
                <li>
                  {" "}
                  Open access directories: Vérif.com, Societe.com,{" "}
                  <a
                    href={`http://Kompass.fr`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Kompass.fr
                  </a>{" "}
                  …
                </li>
                <li>
                  {" "}
                  OpenData files from public administrations, health, education,
                  associations...
                </li>
              </ul>
            </Stack>
          ),
        },
        {
          url: "database-constitution",
          title: "How is your B2B contact database constituted?",
          content: (
            <Stack>
              <p>
                Thanks to our scripts and our intelligent algorithms, we
                aggregate
              </p>
              <p>
                every day more than 20 sources of qualified professional files.
                <br />
              </p>
              <p>
                The profiles in our B2B database are structured, merged,
                enriched, and re-verified daily.
              </p>
            </Stack>
          ),
        },
        {
          url: "does-it-follow-rgpd-guidelines",
          title: "Is your solution compliant with GDPR regulations?",
          content: (
            <Stack>
              <p>
                <b>Yes</b>, our solution complies with the GDPR (General Data
                Protection Regulation).
                <br />
              </p>
              <p>
                It is a regulation adopted by the European Parliament on April
                14, 2016, and which came into effect in the European Union on
                May 24, 2018.
                <br />
              </p>
              <ul>
                <li>
                  Our database is made up of information that we collect from
                  more than 20 sources of qualified professional files and in
                  Open-data as well as Insee data, which we aggregate and
                  structure through our intelligent algorithms.
                </li>
                <li>
                  {" "}
                  We only work on B2B data, not subject to prior consent as
                  stipulated by Article 6 of the CNIL by the e-Privacy directive
                  which prevails over the GDPR, and transposed into French law.
                </li>
                <li>
                  {" "}
                  We respect the obligation to put an unsubscribe link on each
                  of our clients' campaigns.
                </li>
                <li>
                  {" "}
                  If the client forgets to put an unsubscribe link or if it is
                  misspelled, then our system detects it and AUTOMATICALLY adds
                  a clear unsubscribe link at the bottom of the page.
                </li>
                <li>
                  {" "}
                  To inform the internet user of the information we hold, the
                  origin of the collection, as well as the deletion of their
                  information that we hold.
                </li>
                <li>
                  {" "}
                  We can also exclude the email, domain, or SIREN number of
                  companies that request it in order to no longer prospect them.
                </li>
                <li>
                  {" "}
                  Each client can import their lists (MD5 encryption) of
                  contacts, domains, or SIRENs to exclude from your campaigns.
                </li>
              </ul>
            </Stack>
          ),
        },
      ],
    },
  ];

  if (reseller?.name === "Magileads") {
    result[0].items.unshift(
      {
        url: "import-linkedin",
        title: "Create a list from LinkedIn",
        content: (
          <Stack>
            <p>
              With {reseller?.name}, you can create contact lists from a search
              on LinkedIn or Sales Navigator. You must therefore have a LinkedIn
              account.
              <br />
            </p>
            <p>
              The principle is simple, from your LinkedIn account, you search
              for contacts on the LinkedIn site and copy/paste the link of your
              search onto the
              {reseller?.name} platform.
              <br />
            </p>
            <p>
              Thus, the system will create a list of contacts corresponding to
              the profiles you targeted on LinkedIn.
              <br />
            </p>
            <p>
              To import your LinkedIn contacts, click on the link:{" "}
              <a
                href={`https://${
                  reseller?.domain_saas3 || reseller?.domain_saas2
                }/contact-lists/import/linkedin`}
                target="_blank"
                rel="noreferrer"
              >
                https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                /contact-lists/import/linkedin
              </a>{" "}
              then click on Search on LinkedIn
            </p>
            <p>Or go to the "Contact" &gt; Search on LinkedIn</p>
            <p>You have several possibilities: </p>
            <b>
              {" "}
              Extract contacts from a LinkedIn/Sales Navigator search by
              following the steps below:
              <br />
            </b>
            <ol>
              <li> Perform your search on LinkedIn/Sales Navigator. </li>
              <li>
                {" "}
                Copy the URL link of your search page on LinkedIn or Sales
                Navigator.
              </li>
              <li>
                {" "}
                Paste in the "LinkedIn URL of the search" section &gt; Next.
              </li>
              <li>
                {" "}
                Choose the number of profiles to extract, which must be greater
                than or equal to the number of contacts found at the end of your
                search&gt;Next.
              </li>
              <li>
                {" "}
                Select the LinkedIn account with which you want to extract the
                contacts&gt;Next
              </li>
              <li> Give a name to your list.</li>
              <li>
                {" "}
                Check the box enrich my list if you want to obtain the
                professional email addresses of your contacts.&gt;Next. <br />
              </li>
            </ol>
            <p>
              {" "}
              <b>Note </b>: The system is importing your list, it takes 20
              minutes to extract 2000 contacts, you will find your list in
              "Contacts"{" "}
            </p>
            <p>
              <b>
                Extract contacts who commented/liked a post on LinkedIn by
                following the steps below:
                <br />
              </b>
            </p>
            <ol>
              <li>
                {" "}
                In LinkedIn, once on the post of your choice, click on the 3
                small dots at the top right of the post and select "Copy link to
                post"{" "}
              </li>
              <li>
                {" "}
                In {reseller?.name}, under "Contacts" then "Targeting" then
                "Search on LinkedIn" select "Extract contacts who commented on a
                post on LinkedIn" or "Extract contacts who liked a post on
                LinkedIn"
              </li>
              <li>
                {" "}
                Paste the URL link in the "LinkedIn URL of the search" section.
              </li>
              <li>
                {" "}
                Choose the number of profiles to extract, which must be greater
                than or equal to the number of contacts found at the end of your
                search&gt;Next.{" "}
              </li>
              <li>
                {" "}
                Select the LinkedIn account with which you want to extract the
                contacts.&gt;Next.
              </li>
              <li> Give a name to your list&gt;Next</li>
              <li>
                {" "}
                Check the box enrich my list if you want to obtain the
                professional email addresses of your contacts.
              </li>
              <li>
                {" "}
                The system imports your list, you will find your list in
                "Contacts"
                <br />
              </li>
            </ol>
            <p>
              {" "}
              <b>
                Extract contacts connected to your LinkedIn network (level 1) by
                following the steps below:
                <br />
              </b>
            </p>
            <ol>
              <li>
                {" "}
                In {reseller?.name}, under "Targeting" then "Search on LinkedIn"
                select "Extract your connections on LinkedIn"
              </li>
              <li> Specify the number of profiles to import </li>
              <li>
                {" "}
                Select the LinkedIn account with which you want to extract the
                contacts.&gt;Next
              </li>
              <li> Give a name to your list&gt;Next</li>
              <li>
                {" "}
                Check the box enrich my list if you want to obtain the
                professional email addresses of your contacts.
              </li>
              <li>
                {" "}
                The system imports your list, you will find your list in
                "Contacts"
              </li>
            </ol>
            <p>
              <b>
                Extract publishers of job offers on LinkedIn by following the
                steps below:
                <br />
              </b>
            </p>
            <ol>
              <li>
                {" "}
                Launch your job search on LinkedIn by selecting "jobs" in
                LinkedIn.
              </li>
              <li> Copy the link of your search.</li>
              <li>
                {" "}
                Paste this link in {reseller?.name}, under "Targeting" then
                "Search on LinkedIn" then "Extract publishers of job offers on
                LinkedIn"
              </li>
              <li>
                {" "}
                Choose the number of profiles to extract, which must be greater
                than or equal to the number of contacts found at the end of your
                search&gt;Next.{" "}
              </li>
              <li>
                {" "}
                Select the LinkedIn account with which you want to extract the
                contacts.&gt;Next
              </li>
              <li> Give a name to your list&gt;Next</li>
              <li>
                {" "}
                Check the box enrich my list if you want to obtain the
                professional email addresses of your contacts.
              </li>
              <li>
                {" "}
                The system imports your list, you will find your list in
                "Contacts".
              </li>
            </ol>
          </Stack>
        ),
      },
      {
        url: "import-google",
        title: "Create a list from Google Maps",
        content: (
          <Stack>
            <p>
              With {reseller?.name}, from your Google account, you can create
              contact lists from a Google Maps search by following the steps
              below:
            </p>
            <p>
              {" "}
              <br />
              You can create a contact list from a Google Maps search via the
              following link:{" "}
              <a
                href={`https://${
                  reseller?.domain_saas3 || reseller?.domain_saas2
                }/contact-lists/import/google`}
                target="_blank"
                rel="noreferrer"
              >
                https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                /contact-lists/import/google
              </a>{" "}
              <br />
              Or go to the "Targeting&gt;Google" tab
            </p>
            <p>
              <br />
            </p>
            <ol>
              <li>
                Go to Google Maps to do a search by putting in your search
                elements, namely the job title and the geographical location:
                Example IT in Paris.{" "}
                <a
                  href={`https://www.google.com/maps/search/informatique+paris/@48.8592223,2.3418555,13z/data=!3m1!4b1?entry=ttu`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://www.google.com/maps/search/informatique+paris/@48.8592223,2.3418555,13z/
                </a>{" "}
                <br /> <br />
              </li>
              <li>
                {" "}
                In your browser's search bar, copy the URL link of your Google
                Maps search page. Example:{" "}
                <a
                  href={`https://www.google.com/maps/search/informatique+paris/@48.8592223,2.3418555,13z/data=!3m1!4b1?entry=ttu`}
                  target="_blank"
                  rel="noreferrer"
                >
                  https://www.google.com/maps/search/informatique+paris/@48.8592223,2.3418555,13z/data=!3m1!4b1?entry=ttu
                </a>
                <br />
              </li>
              <li>
                {" "}
                Paste the URL link in {reseller?.name} under the
                "Targeting&gt;Google" tab to extract the results of a Google
                Maps search.
                <br />
              </li>
              <li>
                Select your Google account that you have configured. <br />
              </li>
              <li>
                {" "}
                Choose the number of results / profiles to extract.
                <br />
              </li>
              <li>
                {" "}
                Give a name to your list to save it or select the folder and an
                existing contact list.
                <br />
                The system will import your list which you will find in the
                "Contacts" tab.
                <br />
                You can also check the enrichment option "Enrich database
                outside France" for your list in order to complete it with legal
                information and add emails for foreign lists <br />
              </li>
            </ol>
          </Stack>
        ),
      },
      {
        url: "import-database",
        title: "Create a list from the contact database",
        content: (
          <Stack>
            <p>
              You have the possibility on the platform to create a contact list
              from our database of several million BtoB contacts.
              <br />
            </p>
            <p>
              To create a contact list from our database by clicking on the
              following link:{" "}
              <a
                href={`https://${
                  reseller?.domain_saas3 || reseller?.domain_saas2
                }/contact-lists/import/base`}
                target="_blank"
                rel="noreferrer"
              >
                https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                /contact-lists/import/base
              </a>{" "}
              <br />
            </p>
            <p>
              Or go to the <b>Targeting</b> tab
            </p>
            <ul>
              <li>
                You thus have the possibility to refine your search by adding
                more criteria such as job title, field of activity, and even
                geographical area.
              </li>
              <li>
                You can also filter your list by specifying the NAF code, the
                company's activity, its revenue, its legal form, its presence on
                the web: Click on the blue arrow next to each filter each time
                to add your choice.
              </li>
            </ul>
            <p>
              <br />
              To save the contacts found on your list, Click on the "save"
              button to the right of the profiles that appear.
              <br />
            </p>
            <p>
              <b>Note </b>: you have the possibility to create or add these
              contacts to an already created list.
              <br />
            </p>
            <p>
              Your list is thus added in by clicking on the following link:{" "}
              <a
                href={`https://${
                  reseller?.domain_saas3 || reseller?.domain_saas2
                }/contact-lists`}
                target="_blank"
                rel="noreferrer"
              >
                https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                /contact-lists
              </a>{" "}
            </p>
            <p>
              Or go to the <b>Contacts</b> page
            </p>
          </Stack>
        ),
      },
      {
        url: "linkedin-import-not-working",
        title: "LinkedIn contact import is not working",
        content: (
          <Stack>
            <p>
              If your LinkedIn import is not working, you can check these
              points:
            </p>
            <p>
              <br />
              1.Go to{" "}
              <a
                href={`https://${
                  reseller?.domain_saas3 || reseller?.domain_saas2
                }/senders/linkedin`}
                target="_blank"
                rel="noreferrer"
              >
                https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                /senders/linkedin
              </a>
            </p>
            <p>Or in "Configurations" then "LinkedIn Accounts" </p>
            <ul>
              <li>
                Check that your account is still connected
                <br />
                If not, refresh the connection cookie
                <br />
              </li>
            </ul>
            <p></p>
            <p>
              2. Go to{" "}
              <a
                href={`https://{
                  reseller?.domain_saas3 || reseller?.domain_saas2
                }/contact-lists/import/linkedin`}
                target="_blank"
                rel="noreferrer"
              >
                https://{reseller?.domain_saas3 || reseller?.domain_saas2}
                /contact-lists/import/linkedin <br />
              </a>
            </p>
            <p>
              Or in "Targeting"&gt;"LinkedIn"
              <br />
            </p>
            <ul>
              <li>
                <b>A</b> : Check that the imported link is compatible with the
                nature of your LinkedIn account (a non-Sales Navigator account
                cannot import a Sales Navigator link)
                <br />
              </li>
            </ul>
            <ul>
              <li>
                <b>B</b> : Check that the link format is the one requested by
                the system when creating the list
              </li>
            </ul>
            <p></p>
            <p>
              If your import still does not work, do not hesitate to contact us,
              we are here to help you!
            </p>
          </Stack>
        ),
      }
    );
    result[5].items.push({
      url: "cname-error",
      title: "CNAME Error Messages",
      content: (
        <Stack>
          <p>
            <b>Question </b>: I get this error message when I want to access my
            white label
          </p>
          <p>{`{"state":false,"state_message":"action_not_exist","documentation":null}`}</p>
          <p>
            <br />
          </p>
          <p>
            <b>Answer </b>: Perhaps you did not fill in the parameters correctly
            in the software or in the CNAME redirection of your domain.
            <br />
            This problem always comes from a configuration error.
          </p>
          <p>
            <br />
            <b>Check the CNAME records with your domain host</b>
          </p>
          <ul>
            <li>
              Mail sub-domain typed in your CNAME domain
              <br />
              <br />
              <b>Check the parameters in the software</b>
              <br />
            </li>
            <li>Error in typing the domain name in the software</li>
          </ul>
          <p>
            <br />
          </p>
          <p>
            Verification solution: Run <b>nslookup </b>on your computer
            <br />
            <br />
          </p>
          <p>
            The nslookup application is available on most operating systems.{" "}
            <br />
            It allows you to search for information about name servers using a
            command line under Microsoft Windows, Apple Mac, or Linux.
            <br />
            <br />
            To run the command line under Windows, click Start&gt;Run.
          </p>
          <ul>
            <li>Type cmd, then press Enter.</li>
            <li> Under Mac or Linux, start the terminal.</li>
            <li> Enter the following command:</li>
            <li>
              {" "}
              nslookup -q=cname{" "}
              <a href={`saas.example.com`} target="_blank" rel="noreferrer">
                saas.example.com
              </a>{" "}
            </li>
            <li>
              {" "}
              Replace{" "}
              <a href={`http://example.com`} target="_blank" rel="noreferrer">
                example.com
              </a>{" "}
              with the name of the domain containing the CNAME record you want
              to check.
              <br />
              <br />
            </li>
          </ul>
          <p>
            {" "}
            Interpret the result as in the following example,{" "}
            <a href={`example.com`} target="_blank" rel="noreferrer">
              example.com
            </a>{" "}
            :
          </p>
          <p>
            {" "}
            nslookup -q=cname <a href={`saas.exemple.com`}>saas.exemple.com</a>
          </p>
          <p>
            {" "}
            <br />
            With this example, we get the following data:
          </p>
          <p> Server: box </p>
          <p> Address: 192.168.1.1</p>
          <p> Non-authoritative answer:</p>
          <p>
            {" "}
            <a href={`saas.exemple.com`} target="_blank" rel="noreferrer">
              saas.exemple.com
            </a>
            canonical name =
            <a
              href={`resellers-pool1.staging.magileads.net`}
              target="_blank"
              rel="noreferrer"
            >
              resellers-pool1.staging.magileads.net
            </a>
            .
          </p>
          <p>
            {" "}
            <br />
            The information sought is in the last two lines. <br />
            More precisely, the result tells us that{" "}
            <a href={`saas.exemple.com`} target="_blank" rel="noreferrer">
              saas.exemple.com
            </a>{" "}
            points to the name r
            <a
              href={`resellers-pool1.staging.magileads.net.`}
              target="_blank"
              rel="noreferrer"
            >
              esellers-pool1.staging.magileads.net.
            </a>
          </p>
          <p>
            <br />
          </p>
          <p>
            You can also test your sub-domains on this link if you know the IP
            of your host:{" "}
            <a
              href={`https://www.saas-secure.com/online-services/nslookup.html`}
              target="_blank"
              rel="noreferrer"
            >
              https://www.saas-secure.com/online-services/nslookup.html
            </a>
          </p>
          <p>
            <br />
          </p>
          <p></p>
        </Stack>
      ),
    });
  }

  return result;
}
